import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export class PurposeProgress {
  constructor() {
    this.isInitialized = false
    this.scrollTrigger = null
    this.timeline = null
    this.resizeHandler = null

    this.purposeSVGs = gsap.utils.toArray(".purpose_card_svg")
    this.purposeContents = gsap.utils.toArray(".purpose_card_content")
    this.purposeDot = document.querySelector(".purpose_progress_dot")
  }

  init() {
    if (this.isInitialized) return

    gsap.registerPlugin(ScrollTrigger)
    this.initAnimation()
    this.bindResize()
    this.isInitialized = true
  }

  initAnimation() {
    this.cleanup()

    this.timeline = gsap.timeline()
      .set(this.purposeSVGs, { color: "#DFDFDF" })
      .set(this.purposeContents, { opacity: 0.5 })
      // Animate the line
      .fromTo(".purpose_progress_line", {
        height: "0%",
      }, {
        height: "100%",
        transformOrigin: "top center",
        duration: 1,
        ease: "power1.out",
      })
      .to(this.purposeSVGs[0], {
        color: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0)
      .to(this.purposeSVGs[0].querySelector('path'), {
        stroke: "#FFFFFF",
        duration: 0.2,
        ease: "power2.out"
      }, 0)
      .to(this.purposeContents[0], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.purposeSVGs[1], {
        color: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0.1)
      .to(this.purposeSVGs[1].querySelector('path'), {
        stroke: "#FFFFFF",
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.purposeContents[1], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.purposeSVGs[2], {
        color: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0.4)
      .to(this.purposeSVGs[2].querySelector('path'), {
        stroke: "#FFFFFF",
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.purposeContents[2], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.purposeDot, {
        scale: 0,
        marginTop: "-1rem",
        duration: 0.2,
        ease: "power2.out"
      }, ">.1")

    const trigger = ScrollTrigger.create({
      trigger: ".purpose_progress_wrap",
      start: "top 55%",
      end: "bottom center",
      scrub: true,
      animation: this.timeline,
    })
  }

  bindResize() {
    this.resizeHandler = this.debounceResize(() => {
      ScrollTrigger.refresh()
      this.initAnimation()
    }, 250)
    window.addEventListener("resize", this.resizeHandler)
  }

  debounceResize(fn, ms) {
    let last = innerWidth
    let timer
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (innerWidth !== last) {
          last = innerWidth
          fn.apply(this, args)
        }
      }, ms)
    }
  }

  cleanup() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill()
      this.scrollTrigger = null
    }
    if (this.timeline) {
      this.timeline.kill()
      this.timeline = null
    }
  }

  destroy() {
    this.cleanup()
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler)
      this.resizeHandler = null
    }

    this.isInitialized = false
  }
}